import React, {useState} from 'react';
import {useDispatch} from 'react-redux';
import {setPlayerAuth} from '../../redux/actions';
import {API_BASE} from '../../utils/apiConfig';
import {LoadedImage} from '../EmblaCarousel/FactionsCarousel';
import PageButton from '../elements/PageButton/PageButton';
import VersionLabel from '../VersionLabel/VersionLabel';
import MusicMuteToggleButton from '../MusicMuteToggleButton/MusicMuteToggleButton';
import './AuditLoginPage.css';

/**
 * AUDIT_LOGIN_TEMP — ВРЕМЕННАЯ страница входа по логину и паролю для
 * аудиторской проверки. Инструкция по полному удалению —
 * server/config/auditLogin.js.
 *
 * Отдельная страница, а не режим UserNamePage: тот отвечает за никнейм при
 * регистрации через Яндекс ID и за dev-вход, и подмешивать в него временный
 * сценарий значило бы оставить следы в постоянном коде. Показывается только по
 * адресу /audit-login и только при отсутствии сессии (см. App).
 *
 * Единственная рабочая пара учетных данных проверяется на сервере
 * (server/config/auditLogin.js) — здесь никаких проверок и подсказок нет.
 */
function AuditLoginPage({onAuth}) {
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const dispatch = useDispatch();

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (isSubmitting) return;

    setError(null);
    setIsSubmitting(true);
    try {
      const res = await fetch(`${API_BASE}/auth/audit-login`, {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        credentials: 'include',
        body: JSON.stringify({login, password}),
      });

      if (!res.ok) {
        let message = 'Неверный логин или пароль';
        try {
          const errorData = await res.json();
          if (errorData.error) {
            message = errorData.error;
          }
        } catch {
          // тело ответа может быть не json — оставляем сообщение по умолчанию
        }
        throw new Error(message);
      }

      const {user} = await res.json();
      dispatch(setPlayerAuth(user));
      onAuth(user);
    } catch (submitError) {
      setError(submitError.message);
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <MusicMuteToggleButton pageId={'AuditLoginPage'}/>
      <LoadedImage
        className={'loading-screen-bust main-menu-bust margin-top-auto'}
        src={'/img/other/strategikon_bust.png'}
      />
      <h1 className="auth-page-title">Стратегикон</h1>
      <form className="auth-form" onSubmit={handleSubmit}>
        <label className="auth-label" htmlFor="audit-login-name">Логин:</label>
        <input
          id="audit-login-name"
          className="auth-input"
          type="text"
          autoComplete="username"
          value={login}
          onChange={(e) => {
            setLogin(e.target.value);
            if (error) setError(null);
          }}
          autoFocus
        />

        <label className="auth-label" htmlFor="audit-login-password">Пароль:</label>
        <input
          id="audit-login-password"
          className="auth-input"
          type="password"
          autoComplete="current-password"
          value={password}
          onChange={(e) => {
            setPassword(e.target.value);
            if (error) setError(null);
          }}
        />

        {error && <p className="auth-error audit-login-error">{error}</p>}

        <PageButton type="submit" pageId="AuditLoginPage" buttonId="submit" disabled={isSubmitting}>
          Войти
        </PageButton>
      </form>
      <div className="auth-page-copyright">
        {`™ Стратегикон, ${new Date().getFullYear()}, все права защищены`}
      </div>
      <VersionLabel/>
    </>
  );
}

export default AuditLoginPage;
